import Vue from 'vue';

import store from '../../store/';
import Voucher from './Voucher.vue';
import Loading from '../Loading.vue';

const $mount = document.getElementById('order-voucher');

if ($mount) {
    new Vue({
        el: $mount,
        store,
        render() {
            const amountsPredefined = $mount.getAttribute('data-amounts-predefined').replace(' ', '').split(',');
            return <Voucher amountsPredefined={amountsPredefined} />;
        },
    });

    // loading overlay
    new Vue({
        el: document.getElementById('order-loading-modal'),
        store,
        render() {
            return this.$store.state.loadingModalVisible ? <Loading text={this.$store.state.loadingModalMessage} /> : null;
        },
    });
}



// WEBPACK FOOTER //
// ./static/js/Order/components/Voucher/index.js